import { render, staticRenderFns } from "./ViewGeneratedDocuments.vue?vue&type=template&id=8048e3fe"
import script from "./ViewGeneratedDocuments.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewGeneratedDocuments.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports